import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { autoinject, inject } from '../Utils/AutoInject';
import { TooltipsStore } from '../Utils/TooltipsStore';
import { InfoTooltip } from './InfoTooltip';
import { Placement } from './Tooltip';

export interface IHelpTooltipProps {
    readonly subject?: string;
    readonly subjects?: string[];
    readonly name: string;
    readonly underline?: boolean;
    readonly className?: string;
    readonly placement?: Placement;
}

@autoinject
@observer
export class HelpTooltip extends React.Component<IHelpTooltipProps> {
    @action
    public async componentDidMount() {
        this.loading = true;
        try {
            const promises = this.subjects.map(s => this.tooltipsStore.loadTooltipsForSubjectAsync(s));
            await Promise.all(promises);
        } catch (e: any) {
            console.error(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <InfoTooltip
                message={this.message}
                className={this.className + ' test'}
                placement={this.props.placement}
                loading={this.loading}
            >
                {this.props.children}
            </InfoTooltip>
        );
    }

    @computed
    private get message() {
        const tooltips = this.subjects.map(s => this.tooltipsStore.getTooltip(s, this.props.name));
        const tooltip = tooltips.find(t => !!t);

        if (tooltip) {
            return tooltip.description;
        }
    }

    @computed
    private get className() {
        if (this.props.underline) {
            return this.props.className + ' dotted-underline';
        } else return this.props.className;
    }

    @computed
    private get subjects() {
        let subjects: string[] = [];
        if (this.props.subject) subjects.push(this.props.subject);
        if (this.props.subjects) subjects = subjects.concat(this.props.subjects);

        return subjects;
    }

    @observable
    private loading: boolean = false;
    @inject
    private tooltipsStore!: TooltipsStore;
}
